import Swiper, { Autoplay, Pagination } from 'swiper'

Swiper.use([Autoplay, Pagination])

function initFeaturePanelCarousels() {

  const featurePanelCarousels = Array.from(document.querySelectorAll('.js-feature-panel-carousel'))

  featurePanelCarousels.forEach(featurePanelCarousel => {

    const paginationEl = featurePanelCarousel.querySelector('.js-feature-panel-carousel-pagination')

    const swiper = new Swiper(featurePanelCarousel, {
      speed: 800,
      grabCursor: true,
      slidesPerView: 1.1,
      spaceBetween: 24,
      centeredSlides: true,
      watchOverflow: true,
      autoplay: {
        delay: 8000
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.1,
          centeredSlides: false,
          centerInsufficientSlides: true,
        },
        992: {
          slidesPerView: 3.1,
          centeredSlides: false,
          centerInsufficientSlides: true,
        },
        1200: {
          slidesPerView: 4.2,
          spaceBetween: 36,
          centeredSlides: false,
          centerInsufficientSlides: true,
        },
        1400: {
          slidesPerView: 4.5,
          spaceBetween: 36,
          centeredSlides: false,
          centerInsufficientSlides: true,
        }
      }
    })

  })
}
initFeaturePanelCarousels()
